import React from 'react';
import { TextField as MaterialUiTextField } from '@material-ui/core';

export function TextFieldWithLabel({ inputType, ...props }) {
  return <MaterialUiTextField {...props} variant="outlined" type={inputType} label={props.placeholder} autoComplete="off" fullWidth />;
}
